import { ApiFindOptions, useApiFind } from '../../../../../lib/HttpService';
import { PATH } from './const';
import { StubbornDatasource } from '../../../../../application/business/StubbornAsset';

export const useEditionDatasourceFind = (options: ApiFindOptions = {}) => useApiFind<StubbornDatasource>(PATH, options);
